'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _nuiIntl = require('@concur/nui-intl');

var _utils = require('../utils');

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/App.css') : void 0;
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('../listings/style/slick-carousel.css') : void 0;

var _userProfileModule = require('../userProfile/userProfileModule');

var _utilsModule = require('../utils/utilsModule');

var _listingsModule = require('../listings/listingsModule');

var _listingModule = require('../listing/listingModule');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var urlToLang = function urlToLang(url) {
  return (0, _utils.mapCountryToPublicLang)((0, _utils.getCountryCode)(url));
};

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.title = '', _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _this2 = this;

      return {
        userProfile: this.props.userProfile,
        isPublic: (0, _utils.isPublic)(this.props.location.pathname),
        getTitle: function getTitle(newTitle) {
          if (newTitle !== _utils.HOME) {
            return newTitle + ' - ' + _this2.title;
          }
          return _this2.title;
        }
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.isAppCenterEnabledCheck();
      this.props.setIsPublic((0, _utils.isPublic)(this.props.location.pathname));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if ((0, _utils.canUseDOM)() && (0, _utils.isPublic)(this.props.location.pathname)) {
        if (window.utag_data) {
          window.site_regional = urlToLang(this.props.meta.originalhost);
        }
      }
      this.loadTrustArcScript();
    }
  }, {
    key: 'loadTrustArcScript',
    value: function loadTrustArcScript() {
      var script = document.createElement("script");
      script.src = "//consent.trustarc.com/notice?domain=concur.com&c=teconsent&js=nj&noticeType=bb&text=true";
      script.async = true;
      var footerElement = document.getElementById("teconsent");
      footerElement.appendChild(script);
      this.props.fetchListingsIfNeeded();
      this.props.fetchLocalizedRegions();
      this.props.fetchLocalizedCountries();
      this.props.fetchCategoriesIfNeeded();
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {};
      var scripts = [];
      this.title = 'AppCenter';
      var links = [{
        href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.3.15/slick.css',
        rel: 'stylesheet',
        type: 'text/css'
      }];

      // TODO: figure out why the details page won't update canonical, then re-enable
      if ((0, _utils.isPublic)(this.props.location.pathname)) {
        this.title = 'SAP Concur App Center';
        style.backgroundColor = '#efefef';

        scripts = [{ src: '//code.jquery.com/jquery-1.12.4.min.js', type: 'text/javascript' }];

        function getCookie(name) {
          var re = new RegExp(name + "=([^;]+)");
          var value = re.exec(document.cookie);
          return value != null ? unescape(value[1]) : null;
        }

        if ((0, _utils.canUseDOM)()) {
          if (typeof getCookie('notice_preferences') === "undefined" || getCookie('notice_preferences') == null || getCookie('notice_preferences') !== '0:') {
            scripts.push({ src: '//static.concursolutions.com/nui/appcenter/static/omniture.bundle.f4e88b342e6ff25c6df3.js', type: 'text/javascript' });
          }
        }

        if (this.props.meta.originalhost) {
          links.push({ rel: 'canonical', href: '' + (0, _utils.getCanonicalLink)(this.props.meta.originalhost, this.props.location.pathname) });
        }

        links.push({ rel: 'shortcut icon', href: '//www.concur.com/sites/all/themes/concur7/favicon.ico', type: 'image/png' });
        (0, _utils.getHreflangLinks)(links);
      }

      return _react2.default.createElement(
        'div',
        { id: 'app', style: style },
        _react2.default.createElement(_reactHelmet2.default, {
          htmlAttributes: { lang: (0, _utils.getNuiLanguage)(this.props.meta.originalhost) },
          title: this.title,
          meta: [{ 'char-set': 'utf-8' }, {
            name: 'application-name',
            content: this.props.formatter.formattedMessage({ id: 'AppCenterHeader' })
          }, {
            name: 'description',
            content: this.props.formatter.formattedMessage({ id: 'MetaDescription' })
          }, {
            name: 'keywords',
            content: 'Concur App Center, App Center'
          }, {
            name: 'viewport',
            content: 'width=device-width,initial-scale=1'
          }],
          script: scripts,
          link: links
        }),
        _react2.default.createElement(
          'div',
          { className: 'route-content ' + ((0, _utils.isPublic)(this.props.location.pathname) ? 'public-content container' : ''), style: { fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif' } },
          this.props.children
        )
      );
    }
  }]);

  return App;
}(_react.Component);

// We don't own location, formatter, or userProfile so we shouldn't define the shape.
// Ideally the react-router and nui-intl packages would expose the shape and we could consume it.


App.propTypes = {
  children: _propTypes2.default.node,
  isAppCenterEnabledCheck: _propTypes2.default.func.isRequired,
  setIsPublic: _propTypes2.default.func.isRequired,
  meta: _propTypes2.default.shape({
    originalhost: _propTypes2.default.string
  }),
  userProfile: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  location: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  formatter: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userProfile: state.userProfile,
    meta: state.meta
  };
};

var mapDispatchToProps = {
  isAppCenterEnabledCheck: _userProfileModule.isAppCenterEnabledCheck,
  setIsPublic: _utilsModule.setIsPublic,
  fetchListingsIfNeeded: _listingsModule.fetchListingsIfNeeded,
  fetchLocalizedRegions: _listingModule.fetchLocalizedRegions,
  fetchLocalizedCountries: _listingModule.fetchLocalizedCountries,
  fetchCategoriesIfNeeded: _listingsModule.fetchCategoriesIfNeeded
};

App.childContextTypes = {
  userProfile: _propTypes2.default.object,
  isPublic: _propTypes2.default.bool,
  getTitle: _propTypes2.default.func
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _nuiIntl.withFormatter)(App));


//////////////////
// WEBPACK FOOTER
// ./lib/app/App.js
// module id = 558
// module chunks = 0